import React from 'react';
import { Row, Col } from 'reactstrap';
import { SearchResult } from '../Result';
import { Title } from './styles';

export const SearchResultCategory = props => {
  const {
    data: { id, name, questions },
  } = props;
  return (
    <Col xs="12">
      <Title className="mb-3">{name}</Title>
      <Row>
        {questions.map(question => (
          <SearchResult key={`${id} ${question.order}`} data={question} />
        ))}
      </Row>
    </Col>
  );
};
